/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from "react";
import Header from "../Header";
import { BsTrash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import TailwindHeader from "./TailwindHeader";
import TopHeader from "./TopHeader";
import TailwindFooter from "./TailwindFooter";
import { useListing } from "@/providers/ListingsProvider";
// import { ScrollToPreviousPosition } from "@/hooks";

const Layout = ({ children }) => {
  const navigate = useNavigate();

  const { compareList, toggleCompare } = useListing();


  const compareListings = useCallback(async () => {
    navigate('/compare');
  }, [])

  // console.log(compareList);

  return (
    <>
      {/* <ScrollToPreviousPosition> */}
      <div>
        {/* Show TopHeader and TailwindHeader on mobile devices */}
        <div className="block lg:hidden">
          <TopHeader />
          <hr />
          <TailwindHeader />
          <hr />
        </div>

        {/* Show Header on non-mobile devices */}
        <div className="hidden lg:block">
          <Header />
        </div>
        <>
          <input type="checkbox" id="UniqueMenuToggle" />
          <aside className="border-0 shadow-2xl unique-sidebar">
            <nav className="h-[fit-content] p-4">
              <h2 className="mb-4 text-xl font-bold">Stays</h2>
              <div className="listing-item-grid_container overflow-scroll h-[520px] !mb-2">
                <h4> Please add the listings to compare</h4>
                <div className="mx-0 row">
                  {compareList?.map((e) => (
                    <div className="w-full mb-4" key={e.id}>
                      <div className="relative p-4 bg-white rounded-lg shadow">
                        {/* Listing Image */}
                        <div className="relative w-full h-40 overflow-hidden rounded-lg">
                          <img
                            src={
                              e?.images[0]?.image
                            }
                            alt={e.title || "Listing Image"}
                            className="object-cover w-full h-full"
                          />
                          {/* Listing Title Overlay */}
                          <div className="absolute bottom-0 left-0 w-full py-2 text-center text-white bg-black bg-opacity-40">
                            <span className="text-sm font-semibold text-white">{e.title}</span>
                          </div>
                        </div>

                        {/* Trash Icon */}
                        <div className="absolute p-2 bg-gray-200 bg-opacity-50 rounded-full cursor-pointer top-6 right-6">
                          <BsTrash
                            className="text-red-500"
                            onClick={() => toggleCompare(e)}
                            size={16}
                          />
                        </div>
                      </div>
                    </div>
                  ))}


                </div>
              </div>

              {/* Buttons Section */}
              <div className="flex flex-col items-center my-6 space-y-4">
                <button
                  onClick={compareListings}
                  className="w-48 py-2 text-white bg-[#8Ec639] font-bold text-sm rounded-md"
                >
                  Compare
                </button>

                <button
                  onClick={() => document.getElementById("UniqueMenuToggle").click()}
                  className="w-48 py-2 text-white bg-[#af2322] font-bold text-sm rounded-md border border-gray-300"
                >
                  Close
                </button>
              </div>
            </nav>
          </aside>

          <main className="unique-right top-[-20px] lg:top-[210px] !z-[unset]">
            <label htmlFor="UniqueMenuToggle" className="unique-toggle-icon">
              <span className="absolute top-[-14px] left-[-14px] text-xs text-gray-700 font-bold bg-[#8EC639] rounded-full p-1 w-6 h-6 text-center">
                {compareList?.length}
              </span>
              <i className="px-3 py-1 text-2xl text-white bg-black rounded fas fa-bars" />

            </label>
            <div className="unique-content">{children}</div>
          </main>
        </>
        <TailwindFooter />
        {/* <Footer /> */}
      </div>
      {/* </ScrollToPreviousPosition> */}
    </>
  );
};

export default Layout;
